<template>
  <div class="sky-server-config">
    <div class=" wsp-line-height-28 wsp-padding-tb-3" v-if="crmQueryStatus === 'PENDING'">
      <div>当前系统请求获取CRM系统信息，请等待，</div>
      <div class=" wsp-line-height-28 wsp-padding-tb-3">等待倒计时 {{ timeLeft }}</div>
    </div>
    <div class=" wsp-line-height-28 wsp-padding-tb-3" v-if="crmQueryStatus === 'SUCCESS'">
      请求获取成功，准备自动填写
    </div>
    <div class=" wsp-line-height-28 wsp-padding-tb-3" v-if="crmQueryStatus === 'ERROR'">
      数据不存在或者无权限查询数据，请检查CRM单号重新进行获取
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消查询
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Input, Button, RadioButton, RadioGroup } from 'element-ui'

import { createQueryCrmOrderInfo, queryCrmOrderInfo, getCrmOrderDetail } from '@/api/setting'

export default {
  name: 'SkyAsyncCmrOrderInfo',
  components: {
    [Input.name]: Input,
    [RadioButton.name]: RadioButton,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup
  },
  props: {
    crmOrderId: {},
    fromCtrl: null
  },
  data() {
    return {
      requestCount: 0,
      maxRequests: 5,
      timeLeft: 10,
      hasCmrOrderInfo: false,
      cmrOrderInfo: {},
      intervalDown: null,
      crmQueryStatus: 'PENDING',
      queryId: null
    }
  },
  created() {
    this.createQuery()
  },
  mounted() {},
  watch: {},
  methods: {
    createQuery() {
      createQueryCrmOrderInfo({ crmOrderId: this.crmOrderId }).then(res => {
        this.queryId = res.data.content
        this.startMonitoring()
        this.startCountDown()
      })
    },
    startCountDown() {
      this.timeLeft = 10
      this.intervalDown = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft -= 1 // 每秒减少1
        } else {
          this.stopCountdown() // 倒计时结束
        }
      }, 1000) // 每秒更新一次
    },
    stopCountdown() {
      clearInterval(this.intervalDown)
    },
    startMonitoring() {
      this.intervalId = setInterval(() => {
        if (this.requestCount < this.maxRequests && !this.hasCmrOrderInfo) {
          this.queryCrmOrderInfo()
          this.requestCount += 1 // 增加请求计数
        } else {
          this.stopMonitoring() // 达到最大请求次数后停止监控
        }
      }, 2000) // 每隔5秒钟发送一次请求
    },
    queryCrmOrderInfo() {
      queryCrmOrderInfo({ id: this.queryId }).then(res => {
        if (res.data.content.queryStatus === 'SUCCESS') {
          this.crmQueryStatus = 'SUCCESS'
          this.hasCmrOrderInfo = true
          this.stopMonitoring()
          this.getCmrDetail()
        } else if (res.data.content.queryStatus === 'ERROR') {
          this.crmQueryStatus = 'ERROR'
          this.hasCmrOrderInfo = false
          this.stopMonitoring()
        }
      })
    },
    getCmrDetail() {
      getCrmOrderDetail({ crmOrderId: this.crmOrderId }).then(res => {
        this.cmrOrderInfo = res.data.content
        this.$emit('cb', { hasCmrOrderInfo: this.hasCmrOrderInfo, cmrOrderInfo: this.cmrOrderInfo })
      })
    },
    stopMonitoring() {
      clearInterval(this.intervalId)
    },
    onConfirm() {
      this.$emit('cb', { hasCmrOrderInfo: this.hasCmrOrderInfo, cmrOrderInfo: this.cmrOrderInfo })
    },
    onCancel() {
      this.$emit('cb', { hasCmrOrderInfo: this.hasCmrOrderInfo, cmrOrderInfo: this.cmrOrderInfo })
    }
  },
  beforeDestroy() {
    this.stopMonitoring()
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
